var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "yoyo-container mx-auto sticky top-0 left-0 right-0 z-999" },
    [
      _vm.showMobileNavbar
        ? _c(
            "div",
            {
              staticClass:
                "md:hidden h-12 flex items-center bg-white w-full lg:mx-4 lg:w-[calc(100%-2rem)] px-4",
            },
            [
              _c(
                "div",
                { staticClass: "flex-1", on: { click: _vm.onClickLeft } },
                [
                  _vm.showBack
                    ? _c("img", {
                        staticClass: "w-6 h-6",
                        attrs: { src: _vm.backSrc, alt: "" },
                      })
                    : _vm._e(),
                ]
              ),
              _vm._t("title", function () {
                return [
                  _c("div", { staticClass: "flex-2 text-center" }, [
                    _vm._v(_vm._s(_vm.title)),
                  ]),
                ]
              }),
              _vm._t("right", function () {
                return [
                  _c("div", { staticClass: "flex-1" }, [
                    _vm._v(_vm._s(_vm.right)),
                  ]),
                ]
              }),
            ],
            2
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass:
            "h-12 flex items-center justify-between bg-[#fff] hidden md:flex w-full lg:mx-4 lg:w-[calc(100%-2rem)] shadow-[0_4px_6px_-1px_rgba(0,0,0,0.1)]",
        },
        [
          _c("img", {
            staticClass: "w-40 h-auto cursor-pointer",
            attrs: { src: _vm.logoSrc, alt: "" },
            on: { click: _vm.handleLogoClick },
          }),
          _c(
            "div",
            { staticClass: "flex items-center" },
            _vm._l(_vm.filterTabbarItems(), function (item) {
              return _c(
                "div",
                {
                  key: item.name,
                  staticClass:
                    "h-12 flex items-center justify-center px-4 cursor-pointer hover:bg-gray-100 transition-colors duration-200",
                  on: {
                    click: function ($event) {
                      return _vm.handleTabbarClick(item)
                    },
                  },
                },
                [
                  _c("img", {
                    class: ["w-25 h-auto"],
                    attrs: { src: item.icon },
                  }),
                ]
              )
            }),
            0
          ),
        ]
      ),
      _vm._t("navBottom"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }